/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/radar-fetch-client";
import type { ContactActivityQueryResponse, ContactActivityQueryParams, ContactActivityHeaderParams, ContactActivity400 } from "../../models/contactsController/ContactActivity";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/radar-fetch-client";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const contactActivityQueryKey = (params?: ContactActivityQueryParams) => [{ url: '/contacts/activity' }, ...(params ? [params] : [])] as const

export type ContactActivityQueryKey = ReturnType<typeof contactActivityQueryKey>

/**
 * @summary List the authenticated user's contacts, sorted by recency, score, or name
 * {@link /contacts/activity}
 */
export async function contactActivity(params?: ContactActivityQueryParams, headers?: ContactActivityHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ContactActivityQueryResponse, ResponseErrorConfig<ContactActivity400>, unknown>({ method : "GET", url : `/contacts/activity`, params, ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

export function contactActivityQueryOptions(params?: ContactActivityQueryParams, headers?: ContactActivityHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = contactActivityQueryKey(params)
        return queryOptions<ContactActivityQueryResponse, ResponseErrorConfig<ContactActivity400>, ContactActivityQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return contactActivity(params, headers, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List the authenticated user's contacts, sorted by recency, score, or name
 * {@link /contacts/activity}
 */
export function useContactActivity<TData = ContactActivityQueryResponse, TQueryData = ContactActivityQueryResponse, TQueryKey extends QueryKey = ContactActivityQueryKey>(params?: ContactActivityQueryParams, headers?: ContactActivityHeaderParams, options: 
{
  query?: Partial<QueryObserverOptions<ContactActivityQueryResponse, ResponseErrorConfig<ContactActivity400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? contactActivityQueryKey(params)
         

         const query = useQuery({
          ...contactActivityQueryOptions(params, headers, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ContactActivity400>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}